import mitt from 'mitt'
import type { Query } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

type ErrorEvents = Record<string, unknown> & {
  'query:error': {
    error: unknown
    query: Query
    response?: AxiosResponse<any, any>
  }
}

const EventBus = mitt()
export const queryErrorEventBus = mitt<ErrorEvents>()
export default EventBus
